import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CheckmarkIcon = ({
  color = 'foraBlue',
  width = 17,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M13.535 1.133c.605-.659 1.643-.714 2.318-.125.64.559.725 1.496.218 2.153l-.09.106-8.089 8.8c-.621.677-1.686.709-2.35.097l-.096-.097L1.219 7.47C.614 6.811.67 5.8 1.347 5.21c.64-.558 1.605-.537 2.22.026l.098.1L6.67 8.601l6.866-7.47z"
      />
    </svg>
  </DefaultIconWrapper>
);
